/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 利用ページ
 */
export type PatientSocialLoginCallbackBodiesDestination = typeof PatientSocialLoginCallbackBodiesDestination[keyof typeof PatientSocialLoginCallbackBodiesDestination];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientSocialLoginCallbackBodiesDestination = {
  SignUp: 'SignUp',
  Login: 'Login',
  MyPage: 'MyPage',
} as const;
